module.exports = __webpack_public_path__ + "img/Rear muffler.26d34d5a.jpg";